import React, { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { useLottie } from 'lottie-react'

import { getThemeUrl } from 'utils/theme/themeManager'
import { sendRequest, isMobile } from 'utils/utils'
import { THEME_STRATEGY } from 'constants/theme'
import type _Infra from 'mobx/Infra'

interface Props {
	fileName?: string
	filePerDevice: boolean
	alt: string
	width?: string
}

const lottiesCache = new Map<string, object>()

const LottieComponent = inject('Infra')(
	observer((props: Props & { Infra?: typeof _Infra }) => {
		const { Infra, alt = 'failed to load image', fileName, filePerDevice, width = 'unset' } = props
		const themeStrategy = Infra!.appParams.theme || THEME_STRATEGY.GENERIC
		const chainId = Infra?.appParams?.c
		const brand = Infra?.appParams?.brand

		const lottieBasePath = `${getThemeUrl(themeStrategy, chainId!, brand)}/assets/lottie`
		let lottieFilePath = `${lottieBasePath}/${fileName}`

		if (filePerDevice) {
			lottieFilePath = isMobile() ? `${lottieFilePath}/mobile.json` : `${lottieFilePath}/desktop.json`
		} else {
			lottieFilePath = `${lottieFilePath}.json`
		}

		const lottieCache = lottiesCache.get(lottieFilePath)
		const [lottieData, setLottieData] = useState<object | null | undefined>(lottieCache)

		useEffect(() => {
			const init = async () => {
				if (!lottieCache) {
					try {
						const data = (await sendRequest(false, lottieFilePath, 'GET', null, null, undefined, undefined, null, false)) as object
						lottiesCache.set(lottieFilePath, data)
						setLottieData(data)
					} catch (e) {
						console.warn(`LottieComponent - ${e}`)
					}
				}
			}
			init()
		}, [])

		const options = {
			animationData: lottieData,
			loop: true,
		}

		const { View } = useLottie(options)

		return <div style={{ marginBottom: '5px', maxWidth: width }}>{View}</div>
	})
)

export default LottieComponent
